module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact),
      expression: "contact"
    }],
    staticClass: "contact",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "tel",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item address-item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("地址")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "address-value",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "save-address"
  }, [_c('input', {
    staticClass: "save-btn",
    class: {
      'btn-disable': _vm.checkValid()
    },
    attrs: {
      "type": "button",
      "value": "保存"
    },
    on: {
      "click": function($event) {
        return _vm.saveAddress()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-285b0d82"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Address.vue
// module id = 536
// module chunks = 1